import open from "webmodals/open";
import templateUrl from 'emun.salesrep/hardcode-manager/hardcode-prompt.htm'
import controller from "emun.salesrep/hardcode-manager/hardcode-prompt.controller";

export default ({
  size = "md",
  backdrop = "static",
  placement = "center",
  preventAutoHeight = true,
  retailerId = retailerId,
  request = request,
  type = type,
  saveType = saveType,
  title = `Hard Codes`
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      request: () => request,
      type: () => type,
      saveType: () => saveType,
      retailerId: () => retailerId
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;

